export { SELECTION_CHANGE, SelectionDirection, SelectionMode } from '@fluentui/utilities';
export type { IObjectWithKey, ISelection } from '@fluentui/utilities';
